import React from 'react';
import { WebsiteDesignProps } from './types';
import { Book, Landmark, History } from 'lucide-react';
import { Button } from "@/components/ui/button";

const LibraryArchives: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Athenaeum";

    return (
        <div className="bg-[#fcfbf9] text-[#2c1810] min-h-screen font-serif">
            <nav className="p-8 border-b border-[#e5e0d8] flex justify-center sticky top-0 bg-[#fcfbf9] z-50">
                <div className="flex items-center gap-3">
                    <Landmark className="text-[#8b5e3c]" strokeWidth={1} />
                    <span className="text-2xl tracking-widest uppercase font-normal">{schoolName}</span>
                </div>
            </nav>

            <main className="container mx-auto px-8 py-20">
                <div className="text-center max-w-3xl mx-auto mb-20">
                    <span className="text-[#8b5e3c] italic text-lg mb-4 block">Est. 1892</span>
                    <h1 className="text-6xl md:text-7xl mb-8 leading-tight font-normal text-[#2c1810]">
                        Preserving the <br/> Human Record.
                    </h1>
                    <p className="text-xl text-[#5d4037] leading-relaxed mb-12">
                        A sanctuary for scholars and seekers of truth. Our collections span centuries, offering a window into the past to illuminate the future.
                    </p>
                    <div className="flex justify-center gap-6">
                        <Button variant="outline" className="border-[#8b5e3c] text-[#8b5e3c] hover:bg-[#8b5e3c] hover:text-white rounded-none px-10 py-6 uppercase tracking-[0.2em] text-xs">
                            Search Catalog
                        </Button>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-12 border-t border-[#e5e0d8] pt-16">
                    <div className="text-center">
                        <History className="mx-auto mb-6 text-[#8b5e3c]" strokeWidth={1} size={40} />
                        <h3 className="text-xl uppercase tracking-widest mb-4">Archives</h3>
                        <p className="text-[#5d4037] leading-relaxed text-sm px-4">Rare manuscripts, letters, and artifacts available for dedicated research.</p>
                    </div>
                    <div className="text-center border-l md:border-l border-[#e5e0d8]">
                        <Book className="mx-auto mb-6 text-[#8b5e3c]" strokeWidth={1} size={40} />
                        <h3 className="text-xl uppercase tracking-widest mb-4">Digital Library</h3>
                        <p className="text-[#5d4037] leading-relaxed text-sm px-4">Millions of volumes digitized and accessible from anywhere in the world.</p>
                    </div>
                    <div className="text-center border-l md:border-l border-[#e5e0d8]">
                        <Landmark className="mx-auto mb-6 text-[#8b5e3c]" strokeWidth={1} size={40} />
                        <h3 className="text-xl uppercase tracking-widest mb-4">Exhibitions</h3>
                        <p className="text-[#5d4037] leading-relaxed text-sm px-4">Curated displays showcasing the highlights of human intellectual achievement.</p>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default LibraryArchives;
